import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const ActionsWrapper = styled.div`
  padding: 0px 30px;
  display: flex;
  min-height: 48px;
  align-items: center;
  border-bottom: 2px solid ${colors.amber};
`;

export const RightSection = styled.div`
  margin-left: auto;
`;

export const ActionItem = styled.div`
  padding: 0 8px;
  margin: 0 3px;
`;

export const Divider = styled.div`
  border-left: 1px solid ${colors.grey2};
  height: 24px;
  margin: 0 5px 0 16px;
  align-self: center;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .ag-theme-balham {
    .ag-root-wrapper.ag-layout-normal {
      border-top: none;
      border-bottom: none;
    }

    .unclassified-row-group {
      .ag-cell.taxonomy-item {
        border-left-color: ${colors.amber};

        & + .ag-cell.taxonomy-item {
          border-left-color: transparent;
          border-right-color: ${colors.amber};
        }
      }

      &.unclassified-row-group-start {
        .ag-cell.taxonomy-item {
          border-top-color: ${colors.amber};
        }
      }

      &.unclassified-row-group-end {
        .ag-cell.taxonomy-item {
          border-bottom-color: ${colors.amber};
        }
      }
    }
  }
`;

export const Title = styled.div`
  font-weight: normal;
  font-size: 19px;
  line-height: 27px;
  color: ${colors.black};
  margin-right: 24px;
`;
